import { useTranslation } from "react-i18next";
import { useRecentRecipients } from "../api";
import type { P2PRecentRecipient } from "../api";
import RecentRecipientCard from "./RecentRecipientCard.tsx";

interface Props {
  onSelect: (recipient: P2PRecentRecipient) => void;
}

export default function RecentRecipients({ onSelect }: Props) {
  const { t } = useTranslation();
  const { data, isLoading } = useRecentRecipients(5);

  // Loading: thin skeleton row to avoid layout shift on first paint.
  if (isLoading) {
    return (
      <div className="mb-4">
        <div className="flex gap-3 overflow-hidden">
          {Array.from({ length: 5 }).map((_, i) => (
            <div
              key={i}
              className="shrink-0 size-14 rounded-full bg-white/[0.06] skeleton"
            />
          ))}
        </div>
      </div>
    );
  }

  // Empty (new user, no transfers yet) — don't render anything.
  if (!data || data.length === 0) return null;

  return (
    <div className="mb-4">
      <p className="text-xs font-medium text-gray-1 mb-2">
        {t("p2p_recent_recipients") || "So'nggi yuborilganlar"}
      </p>
      <div
        className="flex gap-3 overflow-x-auto -mx-4 px-4"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" } as React.CSSProperties}
      >
        {data.map((r) => (
          <RecentRecipientCard
            key={r.id}
            recipient={r}
            onSelect={onSelect}
          />
        ))}
      </div>
    </div>
  );
}
